import { useMemo, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Modal } from "@/shared/ui";
import { safetySelector } from "@/domains/account/slice";
import PlayerMenuSettingsSafetyChangePasswordNewContainer from "@/domains/playerMenu/containers/settings/safety/change-password/PlayerMenuSettingsSafetyChangePasswordNewContainer";
import PlayerMenuSettingsSafetyChangePasswordAuthentificatorContainer from "@/domains/playerMenu/containers/settings/safety/change-password/method/PlayerMenuSettingsSafetyChangePasswordAuthentificatorContainer";
import PlayerMenuSettingsSafetyChangePasswordEmailContainer from "@/domains/playerMenu/containers/settings/safety/change-password/method/PlayerMenuSettingsSafetyChangePasswordEmailContainer";
import PlayerMenuSettingsSafetyChangePasswordSMSContainer from "@/domains/playerMenu/containers/settings/safety/change-password/method/PlayerMenuSettingsSafetyChangePasswordSMSContainer";
import PlayerMenuSettingsSafetyMethodForChangingPassword from "@/domains/playerMenu/components/settings/safety/changePassword/PlayerMenuSettingsSafetyMethodForChangingPassword";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordContainer({ onClose }: Props) {
  const [currMethod, setCurrMethod] = useState<TfaMethod | null>(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const safety = useAppSelector(safetySelector);
  const [step, setStep] = useState(1);

  const enableTfa = useMemo(() => {
    const methods: TfaMethod[] = [TfaMethod.EMAIL];
    if (safety.isTwoFactorGoogleEnabled) {
      methods.push(TfaMethod.AUTHENTICATOR);
    }
    if (safety.isTwoFactorSmsEnabled) {
      methods.push(TfaMethod.SMS);
    }

    return methods;
  }, [safety]);

  const title = useMemo(() => {
    if (showChangePassword) {
      return "Установка нового пароля";
    }
    switch (currMethod) {
      case TfaMethod.AUTHENTICATOR: {
        if (step === 1) {
          return "Проверочный код для смены пароля";
        }

        return "";
      }
      case TfaMethod.EMAIL:
      case TfaMethod.SMS: {
        if (step === 1) {
          return "Подтверждение смены пароля";
        }
        if (step === 2) {
          return "Проверочный код для смены пароля";
        }
        return "";
      }
      default: {
        return "Смена пароля от аккаунта";
      }
    }
  }, [currMethod, step, showChangePassword]);

  return (
    <Modal open onClose={onClose} title={title} className="h-[49rem]">
      {currMethod ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {showChangePassword ? (
            <PlayerMenuSettingsSafetyChangePasswordNewContainer onClose={onClose} />
          ) : (
            <>
              {currMethod === TfaMethod.AUTHENTICATOR && (
                <PlayerMenuSettingsSafetyChangePasswordAuthentificatorContainer
                  goToChangePassword={() => setShowChangePassword(true)}
                />
              )}
              {currMethod === TfaMethod.EMAIL && (
                <PlayerMenuSettingsSafetyChangePasswordEmailContainer
                  goToChangePassword={() => setShowChangePassword(true)}
                  setStep={setStep}
                />
              )}
              {currMethod === TfaMethod.SMS && (
                <PlayerMenuSettingsSafetyChangePasswordSMSContainer
                  goToChangePassword={() => setShowChangePassword(true)}
                  setStep={setStep}
                />
              )}
            </>
          )}
        </>
      ) : (
        <PlayerMenuSettingsSafetyMethodForChangingPassword
          currMethod={currMethod}
          onChangeMethod={setCurrMethod}
          enableMethods={enableTfa}
        />
      )}
    </Modal>
  );
}
